import React from 'react'
import PropTypes from 'prop-types'

import { Container, Text } from './styles'

const InfoBox = ({ color, label, style }) => {
  return (
    <Container color={color} style={style}>
      <Text color={color}>{label}</Text>
    </Container>
  )
}

InfoBox.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string,
  style: PropTypes.shape({}),
}

InfoBox.defaultProps = {
  color: '',
  label: '',
  style: null,
}

export default InfoBox
